import { render, staticRenderFns } from "./detalleCertificado.vue?vue&type=template&id=048df286&scoped=true"
import script from "./detalleCertificado.vue?vue&type=script&lang=js"
export * from "./detalleCertificado.vue?vue&type=script&lang=js"
import style0 from "./detalleCertificado.vue?vue&type=style&index=0&id=048df286&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "048df286",
  null
  
)

export default component.exports